import axios from 'axios';

// Función para validar si un producto está oculto o no
const validateProduct = async (idproduct) => {
  try {
    const apiUrl = process.env.REACT_APP_API_URL;
    
    const response = await axios.post(apiUrl, new URLSearchParams({
      type: 'validateProduct',
      idProduct: idproduct,
      responsetype: 'json',
    }), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded', 
      },
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export default validateProduct;
